<template>
    <div class="date-picker">
        <div class="input-wrapper" :class="{'disabled':disabled}" @mouseenter="showCancel = true" @mouseleave="showCancel = false">
            <div v-if="isValueEmpty" class="input" @click="togglePanel">Select {{range? 'dates':'date'}}</div>
            <div v-else class="input" @click="togglePanel" v-text="pickerOutput"></div>
        </div>

        <transition name="toggle">
            <div class="date-panel" v-show="panelState" :style="coordinates">
                <div class="panel-header" v-show="panelType !== 'year'">
                    <div class="arrow-left" @click="prevMonthPreview()">&lt;</div>

                    <div class="year-month-box">
                        <div class="year-box" @click="chType('year')" v-text="tmpYear"></div>
                        <div class="month-box" @click="chType('month')">{{tmpMonth + 1 | month(language)}}</div>
                    </div>

                    <div class="arrow-right" @click="nextMonthPreview()">&gt;</div>
                </div>

                <div class="panel-header" v-show="panelType === 'year'">
                    <div class="arrow-left" @click="chYearRange(0)">&lt;</div>

                    <div class="year-range">
                        <span v-text="yearList[0]"></span> - <span v-text="yearList[yearList.length - 1]"></span>
                    </div>

                    <div class="arrow-right" @click="chYearRange(1)">&gt;</div>
                </div>

                <div class="type-year" v-show="panelType === 'year'">
                    <ul class="year-list">
                        <li v-for="item in yearList"
                            v-text="item"
                            :class="{selected: isSelected('year', item), invalid: validateYear(item)}"
                            @click="selectYear(item)">
                        </li>
                    </ul>
                </div>

                <div class="type-month" v-show="panelType === 'month'">
                    <ul class="month-list">
                        <li v-for="(item, index) in monthList"
                            :class="{selected: isSelected('month', index), invalid: validateMonth(index)}"
                            @click="selectMonth(index)">
                            {{item | month(language)}}
                        </li>
                    </ul>
                </div>

                <div class="type-date" v-show="panelType === 'date'">
                    <ul class="weeks">
                        <li v-for="item in weekList">{{item | week(language)}}</li>
                    </ul>

                    <ul class="date-list">
                        <li v-for="(item, index) in decoratedDateList"
                            :class=" {
                                preMonth: item.previousMonth, 
                                nextMonth: item.nextMonth,
                                invalid: validateDate(item), 
                                firstItem: (index % 7) === 0,
                                'in-hover-range': isInHoverRange(getTimestamp(item)),
                                'selected-start': item.state === 'start',
                                'selected-mid':   item.state === 'mid',
                                'selected-end':   item.state === 'end'
                            }"
                            @click="selectDate(item)"
                            @mouseover="onHover(item)"
                            @mouseleave="onLeave">
                           
                            <div class="message" :class="{selected: isSelected('date', item)}">
                                <div class="bg"></div>
                                <span v-text="item.value"></span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        data () {
            let now = new Date();
            return {
                showCancel: false,
                panelState: false,
                panelType: 'date',
                coordinates: {},
                year: now.getFullYear(),
                month: now.getMonth(),
                date: now.getDate(),
                tmpYear: now.getFullYear(),
                tmpMonth: now.getMonth(),
                tmpStartYear: now.getFullYear(),
                tmpStartMonth: now.getMonth(),
                tmpStartDate: now.getDate(),
                tmpEndYear: now.getFullYear(),
                tmpEndMonth: now.getMonth(),
                tmpEndDate: now.getDate(),
                minYear: Number,
                minMonth: Number,
                minDate: Number,
                maxYear: Number,
                maxMonth: Number,
                maxDate: Number,
                yearList: Array.from({length: 12}, (value, index) => new Date().getFullYear() + index),
                monthList: [1, 2, 3 ,4 ,5, 6, 7 ,8, 9, 10, 11, 12],
                weekList: [0, 1, 2, 3, 4, 5, 6],
                rangeStart: false,
                rangeStartTs: null,
                hoverTs: null,
            }
        },
        props: {
            language: {
                default: 'en'
            },
            min: {
                default: '1970-01-01'
            },
            max: {
                default: '3016-01-01'
            },
            value: {
                type: [String, Array],
                default: ''
            },
            range: {
                type: Boolean,
                default: false
            },
            enableClear: {
                type: Boolean,
                default: true
            },
            clearOutside: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            showFromTo: {
                type: Boolean,
                default: true
            },
        },
        methods: {
            onHover(item) {
                if (this.range && this.rangeStart) {
                    this.hoverTs = this.getTimestamp(item);
                }
            },
            onLeave() {
                this.hoverTs = null;
            },
            getTimestamp(item) {
                let m = this.tmpMonth;

                if (item.previousMonth) m--;
                if (item.nextMonth) m++;

                return new Date(this.tmpYear, m, item.value).getTime();
            },
            togglePanel() {
                if (this.disabled) {
                    return false;
                }

                this.panelState = !this.panelState;
                this.rangeStart = false;
            },
            isSelected(type, item) {
                switch (type){
                    case 'year':
                        if (!this.range) return item === this.tmpYear;

                        return (new Date(item, 0).getTime() >= new Date(this.tmpStartYear, 0).getTime()
                            && new Date(item, 0).getTime() <= new Date(this.tmpEndYear, 0).getTime());
                    case 'month':
                        if(!this.range) return item === this.tmpMonth && this.year === this.tmpYear;

                        return (new Date(this.tmpYear, item).getTime() >= new Date(this.tmpStartYear, this.tmpStartMonth).getTime()
                            && new Date(this.tmpYear, item).getTime() <= new Date(this.tmpEndYear, this.tmpEndMonth).getTime());
                    case 'date':
                        if(!this.range) return this.date === item.value && this.month === this.tmpMonth && item.currentMonth;

                        let month = this.tmpMonth;
                        item.previousMonth && month--;
                        item.nextMonth && month++;

                        return (new Date(this.tmpYear, month, item.value).getTime() >= new Date(this.tmpStartYear, this.tmpStartMonth, this.tmpStartDate).getTime()
                            && new Date(this.tmpYear, month, item.value).getTime() <= new Date(this.tmpEndYear, this.tmpEndMonth, this.tmpEndDate).getTime());
                }
            },
            chType(type) {
                this.panelType = type;
            },
            chYearRange(next) {
                if (next) {
                    this.yearList = this.yearList.map((i) => i + 12);
                } else {
                    this.yearList = this.yearList.map((i) => i - 12);
                }
            },
            prevMonthPreview() {
                if (this.tmpMonth === 0) {
                    this.tmpYear--;
                    this.tmpMonth = 11;
                } else {
                    this.tmpMonth--;
                }
            },
            nextMonthPreview() {
                if (this.tmpMonth === 11) {
                    this.tmpYear++;
                    this.tmpMonth = 0;
                } else {
                    this.tmpMonth++;
                }
            },
            selectYear(year) {
                if (this.validateYear(year)) return;
                this.tmpYear = year;
                this.panelType = 'month';
            },
            selectMonth(month) {
                if (this.validateMonth(month)) return;
                this.tmpMonth = month;
                this.panelType = 'date';
            },
             selectDate(date) {
                setTimeout(() => {
                    if (this.validateDate(date)) return;

                    if (date.previousMonth) {
                        if (this.tmpMonth === 0) {
                            this.year--;
                            this.tmpYear--;
                            this.month = this.tmpMonth = 11;
                        } else {
                            this.month = this.tmpMonth - 1;
                            this.tmpMonth--;
                        }
                    } else if (date.nextMonth) {
                        if (this.tmpMonth === 11) {
                            this.year++;
                            this.tmpYear++;
                            this.month = this.tmpMonth = 0;
                        } else {
                            this.month = this.tmpMonth + 1;
                            this.tmpMonth++;
                        }
                    }

                    // Builds the absolute timestamp of the clicked cell
                    const clickedTs = new Date(
                        this.tmpYear,
                        this.tmpMonth,
                        date.value
                    ).getTime();

                    // Mode single date
                    if (!this.range) {
                        this.year  = this.tmpYear;
                        this.month = this.tmpMonth;
                        this.date  = date.value;

                        const yyyy = this.tmpYear;
                        const mm   = ('0' + (this.month + 1)).slice(-2);
                        const dd   = ('0' + this.date).slice(-2);
                        const value = `${yyyy}-${mm}-${dd}`;

                        this.$emit('input', value);
                        this.panelState = false;

                    // First click on range
                    } else if (this.range && !this.rangeStart) {
                        // Save start of range
                        this.tmpStartYear  = this.tmpEndYear  = this.tmpYear;
                        this.tmpStartMonth = this.tmpEndMonth = this.tmpMonth;
                        this.tmpStartDate  = this.tmpEndDate  = date.value;

                        // Stores start timestamp for hover
                        this.rangeStartTs = clickedTs;
                        this.rangeStart   = true;

                    // Second click on range
                    } else if (this.range && this.rangeStart) {
                        // Define end of range
                        this.tmpEndYear  = this.tmpYear;
                        this.tmpEndMonth = this.tmpMonth;
                        this.tmpEndDate  = date.value;

                        // Sort if necessary
                        const startTs = this.rangeStartTs;
                        const endTs   = clickedTs;

                        if (startTs > endTs) {
                            // Swap dates
                            [ this.tmpStartYear, this.tmpEndYear ]   = [ this.tmpEndYear, this.tmpStartYear ];
                            [ this.tmpStartMonth, this.tmpEndMonth ] = [ this.tmpEndMonth, this.tmpStartMonth ];
                            [ this.tmpStartDate, this.tmpEndDate ]   = [ this.tmpEndDate, this.tmpStartDate ];
                        }

                        // Create strings ISO
                        const sY = this.tmpStartYear;
                        const sM = ('0' + (this.tmpStartMonth + 1)).slice(-2);
                        const sD = ('0' + this.tmpStartDate).slice(-2);
                        
                        const eY = this.tmpEndYear;
                        const eM = ('0' + (this.tmpEndMonth + 1)).slice(-2);
                        const eD = ('0' + this.tmpEndDate).slice(-2);

                        const value = [`${sY}-${sM}-${sD}`, `${eY}-${eM}-${eD}`];
                        this.$emit('input', value);

                        // Reset rangeStart for next use
                        this.rangeStart  = false;
                        this.rangeStartTs = null;
                        this.panelState  = false;
                    }
                }, 0);
            },
            validateYear(year) {
                return (year > this.maxYear || year < this.minYear) ? true : false;
            },
            validateMonth(month) {
                if (new Date(this.tmpYear, month).getTime() >= new Date(this.minYear, this.minMonth - 1).getTime()
                    && new Date(this.tmpYear, month).getTime() <= new Date(this.maxYear, this.maxMonth - 1).getTime()) {
                    
                    return false;
                }
                
                return true;
            },
            validateDate(date) {
                let mon = this.tmpMonth;

                if (date.previousMonth) {
                    mon -= 1;
                } else if (date.nextMonth) {
                    mon += 1;
                }

                if (new Date(this.tmpYear, mon, date.value).getTime() >= new Date(this.minYear, this.minMonth - 1, this.minDate).getTime()
                    && new Date(this.tmpYear, mon, date.value).getTime() <= new Date(this.maxYear, this.maxMonth - 1, this.maxDate).getTime()) {
                    
                    return false;
                }
                
                return true;
            },
            close(e) {
                if (!this.$el.contains(e.target)) {
                    this.panelState = false;
                    this.rangeStart = false;
                }
            },
            clear() {
                this.$emit('input', this.range ? ['', ''] : '');
            }
        },
        watch: {
            min(v) {
                let minArr = v.split('-');
                this.minDate = Number(minArr[0]);
                this.minMonth = Number(minArr[1]);
                this.minYear = Number(minArr[2]);
            },
            max(v) {
                let maxArr = v.split('-');
                this.maxDate = Number(maxArr[0]);
                this.maxMonth = Number(maxArr[1]);
                this.maxYear = Number(maxArr[2]);
            },
            range(newVal, oldVal) {
                if (newVal === oldVal) return;

                if (newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'String') {
                    this.$emit('input', ['', '']);
                }

                if (!newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'Array') {
                    this.$emit('input', '');
                }
            }
        },
        computed: {
            decoratedDateList() {
                const list = this.dateList;

                // While the picker is open after selecting the first date, mark only that date as 'start' and leave all others unmarked
                if (this.range && this.rangeStart) {
                    return list.map(item => {
                        const cellTs = this.getTimestamp(item);
                        
                        return {
                            ...item,
                            state: cellTs === this.rangeStartTs ? 'start' : null
                        };
                    });
                }

                // If range isn’t fully selected, clear all item states
                if (!this.range || !Array.isArray(this.value) || !this.value[0] || !this.value[1]) {
                    return list.map(item => ({ ...item, state: null }));
                }

                // When both dates are selected, label each cell as start, mid, or end
                const [sY, sM, sD] = this.value[0].split('-').map(Number);
                const [eY, eM, eD] = this.value[1].split('-').map(Number);
                const startTs = new Date(sY, sM - 1, sD).getTime();
                const endTs   = new Date(eY, eM - 1, eD).getTime();

                return list.map(item => {
                    const cellTs = this.getTimestamp(item);
                    let state = null;
                    if (cellTs === startTs) state = 'start';
                    else if (cellTs === endTs) state = 'end';
                    else if (cellTs > startTs && cellTs < endTs) state = 'mid';
                    
                    return { ...item, state };
                });
            },
            isInHoverRange() {
                // Returns a function that tests if a timestamp is between startTs and hoverTs
                if (!this.range || !this.rangeStart || this.hoverTs == null) {
                    return () => false;

                }
                const [low, high] = this.rangeStartTs < this.hoverTs
                    ? [this.rangeStartTs, this.hoverTs]
                    : [this.hoverTs, this.rangeStartTs];

                return (cellTs) => cellTs >= low && cellTs <= high;
            },
            dateList() {
                let currentMonthLength = new Date(this.tmpYear, this.tmpMonth + 1, 0).getDate();
                let dateList = Array.from({length: currentMonthLength}, (val, index) => {
                    return {
                        currentMonth: true,
                        value: index + 1
                    };
                });
                let startDay = new Date(this.tmpYear, this.tmpMonth, 1).getDay();
                let previousMongthLength = new Date(this.tmpYear, this.tmpMonth, 0).getDate();

                for (let i = 0, len = startDay; i < len; i++) {
                    dateList = [{previousMonth: true, value: previousMongthLength - i}].concat(dateList);
                }

                for (let i = dateList.length, item = 1; i < 42; i++, item++) {
                    dateList[dateList.length] = {nextMonth: true, value: item};
                }

                return dateList;
            },
            isValueEmpty() {
                return (!this.value[0] && !this.value[1]);
            },
            pickerOutput() {
                if (this.range && this.value[0] && this.value[1]) {
                    var dateFrom;
                    var tempDateFrom;
                    var dateTo;
                    var tempDateTo;

                    tempDateFrom = this.value[0].split('-');
                    
                    if (tempDateFrom && tempDateFrom.length >= 3) {
                        dateFrom = tempDateFrom[2]+'/'+tempDateFrom[1]+'/'+tempDateFrom[0];
                    } else {
                        dateFrom = this.value[0];
                    }

                    tempDateTo = this.value[1].split('-');

                    if (tempDateTo && tempDateTo.length >= 3) {
                        dateTo = tempDateTo[2]+'/'+tempDateTo[1]+'/'+tempDateTo[0];
                    } else {
                        dateTo = this.value[1];
                    }
                }

                if (this.showFromTo) {
                    return this.range ? 'From '+dateFrom + ' to ' + dateTo : this.value;
                } else {
                    return this.range ? dateFrom + ' - ' + dateTo : this.value;
                }
            }
        },
        filters: {
            week: (item, lang) => {
                switch (lang) {
                    case 'en':
                        return {0: 'Su', 1: 'Mo', 2: 'Tu', 3: 'We', 4: 'Th', 5: 'Fr', 6: 'Sa'}[item];
                    case 'ch':
                        return {0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六'}[item];
                    case 'uk':
                        return {0: 'Пн', 1: 'Вт', 2: 'Ср', 3: 'Чт', 4: 'Пт', 5: 'Сб', 6: 'Нд'}[item];
                    case 'es':
                        return {0: 'Do', 1: 'Lu', 2: 'Ma', 3: 'Mi', 4: 'Ju', 5: 'Vi', 6: 'Sa'}[item];
                    default:
                        return item;
                }
            },
            month: (item, lang) => {
                switch (lang) {
                    case 'en':
                        return {1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun',
                         7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'}[item];
                    case 'ch':
                        return {1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六',
                         7: '七', 8: '八', 9: '九', 10: '十', 11: '十一', 12: '十二'}[item];
                    case 'uk':
                        return {1: 'Січень', 2: 'Лютий', 3: 'Березень', 4: 'Квітень', 5: 'Травень', 6: 'Червень',
                         7: 'Липень', 8: 'Серпень', 9: 'Вересень', 10: 'Жовтень', 11: 'Листопад', 12: 'Грудень'}[item];
                    case 'es':
                        return {1: 'Ene', 2: 'Feb', 3: 'Mar', 4: 'Abr', 5: 'May', 6: 'Jun',
                         7: 'Jul', 8: 'Ago', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dic'}[item];
                    default:
                        return item;
                }
            }
        },
        mounted () {
            this.$nextTick(() => {
                if (this.$el.parentNode.offsetWidth + this.$el.parentNode.offsetLeft - this.$el.offsetLeft <= 300) {
                    this.coordinates = {right: '0', top: `${window.getComputedStyle(this.$el.children[0]).offsetHeight + 4}px`};
                } else {
                    this.coordinates = {left: '0', top: `${window.getComputedStyle(this.$el.children[0]).offsetHeight + 4}px`};
                }

                let minArr = this.min.split('-');

                this.minYear = Number(minArr[0]);
                this.minMonth = Number(minArr[1]);
                this.minDate = Number(minArr[2]);

                let maxArr = this.max.split('-');

                this.maxYear = Number(maxArr[0]);
                this.maxMonth = Number(maxArr[1]);
                this.maxDate = Number(maxArr[2]);

                if (this.range) {
                    if (Object.prototype.toString.call(this.value).slice(8, -1) !== 'Array') {
                        throw new Error('Binding value must be an array in range mode.');
                    }

                    if (this.value.length) {
                        let rangeStart = this.value[0].split('-');
                        let rangeEnd = this.value[1].split('-');
                        this.tmpStartYear = Number(rangeStart[0]);
                        this.tmpStartMonth = Number(rangeStart[1]) - 1;
                        this.tmpStartDate = Number(rangeStart[2]);

                        this.tmpEndYear = Number(rangeEnd[0]);
                        this.tmpEndMonth = Number(rangeEnd[1]) - 1;
                        this.tmpEndDate = Number(rangeEnd[2]);
                    } else {
                        this.$emit('input', ['', '']);
                    }
                }

                if (!this.value) {
                    this.$emit('input', '');
                }

                window.addEventListener('click', this.close);
            })
        },
        beforeDestroy () {
            window.removeEventListener('click', this.close);
        }
    }
</script>

<style lang='scss' scoped>
    ul {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .date-picker {
        position: relative;
        height: 32px;
    }

    .input-wrapper {
        border: 1px solid #ccc;
        border-radius: 2px;
        vertical-align: middle;
        display: flex;
        justify-content: space-between;
        flex-flow: row nowrap;
        align-items: center;
        padding: 6px 10px 6px 4px;
        height: 32px;
        box-sizing: border-box;
    }

    .input {
        height: 100%;
        width: 100%;
        font-size: inherit;
        padding-left: 4px;
        box-sizing: border-box;
        outline: none;
    }

    .disabled .input {
        color: #8ca0b3 !important;
        cursor: not-allowed;
    }

    .cancel-btn {
        height: 14px;
        width: 14px;
    }

    .cancel-btn.outside {
        position: absolute;
        right: 9px;
    }

    .date-panel {
        position: absolute;
        z-index: 5000;
        border: 1px solid #eee;
        box-sizing: border-box;
        width: 320px;
        padding: 5px 10px 10px;
        box-sizing: border-box;
        background-color: #fff;
        transform: translateY(4px);
    }

    .panel-header {
        display: flex;
        flex-flow: row nowrap;
        width: 100%;
    }

    .arrow-left, .arrow-right {
        flex: 1;
        font-size: 20px;
        line-height: 2;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
    }

    .year-range {
        font-size: 20px;
        line-height: 2;
        flex: 3;
        display: flex;
        justify-content: center;
    }

    .year-month-box {
        flex: 3;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-around;
    }

    .type-year, .type-month, .date-list {
        background-color: #fff;
    }

    .year-box, .month-box {
        transition: all ease .1s;
        font-family: Roboto, sans-serif;
        flex: 1;
        text-align: center;
        font-size: 20px;
        line-height: 2;
        cursor: pointer;
        background-color: #fff;
    }

    .year-list, .month-list {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;

        li {
            font-family: Roboto, sans-serif;
            transition: all .45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
            cursor: pointer;
            text-align: center;
            font-size: 20px;
            width: 33%;
            padding: 10px 0;

            &:hover {
                background-color: #6ac1c9;
                color: #fff;
            }
            &.selected {
                background-color: #0097a7;
                color: #fff;
            }
            &.invalid {
                cursor: not-allowed;
                color: #ccc;
            }
        }
    }
    .date-list {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        
        .valid:hover {
            background-color: #eee;
        }

        li {
            transition: all ease .1s;
            cursor: pointer;
            box-sizing: border-box;
            border-bottom: 1px solid #fff;
            position: relative;
            margin: 2px;

            &:not(.firstItem) {
                margin-left: 10px;
            }

            .message {
                font-family: Roboto, sans-serif;
                font-weight: 300;
                font-size: 14px;
                position: relative;
                height: 30px;

                &.selected {
                    .bg {
                        background-color: rgba(0, 169, 240, 0.5);
                    }

                    span {
                        color: #fff;
                    }
                }

                &:not(.selected) {
                    .bg {
                        transform: scale(0);
                        opacity: 0;
                    }

                    &:hover {
                        .bg {
                            background-color: rgba(0, 169, 240, 0.5);
                            transform: scale(1);
                            opacity: .6;
                        }
                        span {
                            color: #fff;
                        }
                    }
                }

                .bg {
                    height: 30px;
                    width: 100%;
                    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
                    border-radius: 50%;
                    position: absolute;
                    z-index: 10;
                    top: 0;
                    left: 0;
                }

                span {
                    position: absolute;
                    z-index: 20;
                    left: 50%;
                    top: 50%;
                    transform: translate3d(-50%, -50%, 0);
                }
            }

            &.invalid {
                cursor: not-allowed;
                color: #ccc;
            }
        }
    }

    .weeks {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;

        li {
            font-weight: 600;
        }
    }

    .weeks, .date-list {
        width: 100%;
        text-align: center;

        .preMonth, .nextMonth {
            color: #ccc;
        }
        
        li {
            font-family: Roboto;
            width: 30px;
            height: 30px;
            text-align: center;
            line-height: 30px;
        }
    }

    .toggle-enter, .toggle-leave-active {
        opacity: 0;
        transform: translateY(-10px);
    }

    .toggle-enter-active, .toggle-leave-active {
        transition: all ease .2s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0;
        transform: scale3d(0, 0, 0);
    }

    .fade-enter-active, .fade-leave-active {
        transition: all ease .1s;
    }

    .date-picker.dateRangePicker .date-panel .type-date .date-list li.in-hover-range:hover:not(.selected-start):not(.selected-end) .message .bg {
        background-color: rgba(0, 169, 240, 1) !important;
        transform: scale(1);
        opacity: 1;
    }

    .date-picker.dateRangePicker .date-panel .type-date .date-list li.in-hover-range:not(.selected-start):not(.selected-end) .message .bg {
        background-color: rgba(0, 169, 240, 0.3) !important;
        transform: scale(1);
        opacity: 1;
    }

    /* Intermediate dates */
    .date-picker.dateRangePicker .date-panel .type-date .date-list li.selected-mid .message {
        .bg {
            background-color: rgba(0, 169, 240, 0.3) !important;
            transform: scale(1);
            opacity: 1;
        }

        span {
            color: #000;
        }
    }

    /* Start date and End date */
    .date-picker.dateRangePicker .date-panel .type-date .date-list li.selected-start .message .bg,
    .date-picker.dateRangePicker .date-panel .type-date .date-list li.selected-end   .message .bg {
        background-color: rgba(0, 169, 240, 1) !important;
        transform: scale(1);
        opacity: 1;
    }
    .date-picker.dateRangePicker .date-panel .type-date .date-list li.selected-start .message span,
    .date-picker.dateRangePicker .date-panel .type-date .date-list li.selected-end   .message span {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// DatePicker.vue?3615f118